
import { useState } from "react";
import { useDocumentVerification } from "@/hooks/admin/identity-docs/useDocumentVerification";
import { DocumentProps } from "@/hooks/admin/identity-docs/useSubmittedDocuments";

interface UseDocumentVerificationHandlersProps {
  document: DocumentProps;
  onDocumentUpdated?: () => void;
}

export function useDocumentVerificationHandlers({ 
  document, 
  onDocumentUpdated 
}: UseDocumentVerificationHandlersProps) {
  const { verifyDocument, updatePrimaryDocumentStatus, isProcessing } = useDocumentVerification();
  const [rejectNotes, setRejectNotes] = useState("");
  const [approvalNotes, setApprovalNotes] = useState("");

  const handleReject = async () => {
    await verifyDocument(document, 'rejected', rejectNotes);
    setRejectNotes("");
    if (onDocumentUpdated) onDocumentUpdated();
  };

  const handleApprove = async () => {
    await verifyDocument(document, 'verified', approvalNotes);
    setApprovalNotes("");
    if (onDocumentUpdated) onDocumentUpdated();
  };

  const handleSetPrimary = async () => {
    await updatePrimaryDocumentStatus(document.id, document.user_id);
    if (onDocumentUpdated) onDocumentUpdated();
  };

  return {
    handleReject,
    handleApprove,
    handleSetPrimary,
    rejectNotes,
    setRejectNotes,
    approvalNotes,
    setApprovalNotes,
    isProcessing
  };
}
